import { ReactComponent as MyRequestIcon } from '@Icons/menu/my-request.svg';

import { BaseNameSideItem } from '../../../../../enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const MyRequestsMenuItem: MenuItem = createItem(
  BaseNameSideItem.MY_REQUESTS,
  BaseNameSideItem.MY_REQUESTS,
  <MyRequestIcon />
);

export default MyRequestsMenuItem;
